import React from 'react';
import { AccordionActions } from '@mui/material';
import { ADD_NEW_DOCUMENT_BUTTON, REQUEST_NEW_DOCUMENT } from 'common/constants/documents';
import AddFile from 'icons/AddFile';
import RequestFile from 'icons/RequestFile';
import { DocumentReferencesFooterProps } from './DocumentReferencesFooter.props';
import FooterActionButton from '../buttons/FooterActionButton';

const DocumentReferencesFooter = ({ isDisabled, onClickHandler }: DocumentReferencesFooterProps) => (
  <AccordionActions style={{ display: 'flex', justifyContent: 'start' }}>
    <FooterActionButton
      title={ADD_NEW_DOCUMENT_BUTTON}
      icon={<AddFile />}
      onClick={() => onClickHandler(ADD_NEW_DOCUMENT_BUTTON)}
      isDisabled={isDisabled}
    />
    <FooterActionButton
      title={REQUEST_NEW_DOCUMENT}
      icon={<RequestFile />}
      onClick={() => onClickHandler(REQUEST_NEW_DOCUMENT)}
      isDisabled={isDisabled}
    />
  </AccordionActions>
);

export default DocumentReferencesFooter;
